/**
 * @generated SignedSource<<98808d3488c826c6364290835f4fc7b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternBuildPipelinesPanelSubmitMutation$variables = {
  brandId: string;
  pipelineId: string;
  platform: string;
};
export type InternBuildPipelinesPanelSubmitMutation$data = {
  readonly submitForReview: {
    readonly message: string;
    readonly success: boolean;
  };
};
export type InternBuildPipelinesPanelSubmitMutation = {
  response: InternBuildPipelinesPanelSubmitMutation$data;
  variables: InternBuildPipelinesPanelSubmitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pipelineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "platform"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "pipelineId",
        "variableName": "pipelineId"
      },
      {
        "kind": "Variable",
        "name": "platform",
        "variableName": "platform"
      }
    ],
    "concreteType": "SubmitForReviewPayload",
    "kind": "LinkedField",
    "name": "submitForReview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBuildPipelinesPanelSubmitMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBuildPipelinesPanelSubmitMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1dfde07b446de1dcbd781157934af0f1",
    "id": null,
    "metadata": {},
    "name": "InternBuildPipelinesPanelSubmitMutation",
    "operationKind": "mutation",
    "text": "mutation InternBuildPipelinesPanelSubmitMutation(\n  $brandId: ID!\n  $pipelineId: ID!\n  $platform: String!\n) {\n  submitForReview(brandId: $brandId, pipelineId: $pipelineId, platform: $platform) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac2679ea5a110dcfbab5614e44fbd9b4";

export default node;
